import React from 'react';
import { useTranslation } from 'react-i18next';

import { ProjectDetailsProps } from '../types';

export const ProjectDetails: React.FC<ProjectDetailsProps> = ({ project, errors, touched, onInputChange, onBlur }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-4 px-6 w-full grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <div className="flex items-center gap-2 ">
          <label className="text-xs text-white">{t('settings.project.maintenanceFactor')} (0-1.00)</label>
        </div>
        <input
          type="number"
          step="0.01"
          min="0"
          max="1"
          placeholder="0-1.00"
          value={project.maintenance}
          onChange={onInputChange('maintenance')}
          onBlur={onBlur('maintenance')}
          className={`w-full h-[36px] rounded-lg bg-black border ${
            touched.maintenance && errors.maintenance ? 'border-red-500' : 'border-black'
          } placeholder-gray-500 text-sm px-4 text-gray-300 focus:border-lime-400 
            focus:ring-2 focus:ring-lime-400/30 outline-none transition`}
        />
        {touched.maintenance && errors.maintenance && <p className="text-xs text-red-400 mt-1">{errors.maintenance}</p>}
      </div>

      {/* UNITS */}
      <div>
        <label className="flex items-center text-xs text-white">{t('settings.project.units')}</label>
        <select
          value={project.units || ''}
          onChange={onInputChange('units')}
          className="w-full h-[36px] bg-black border border-black rounded-lg px-4
            text-white text-sm appearance-none cursor-pointer focus:border-lime-400
            focus:ring-2 focus:ring-lime-400/30 outline-none transition"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23a3e635' d='M6 9L1 4h10z'/%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 1rem center',
          }}
        >
          <option value="" disabled>
            {t('projects.newProject.selectUnits')}
          </option>
          <option value="METRIC">{t('settings.project.metric')}</option>
          <option value="IMPERIAL">{t('settings.project.imperial')}</option>
        </select>
      </div>
    </div>
  );
};
